import React, { useState, useContext } from 'react'
import { SideNavigationCategoryProps } from './SideNavigation.types'
import { SideNavigationContext } from './SideNavigation'

const SideNavigationCategory: React.FC<SideNavigationCategoryProps> = ({ id, title, children }) => {
    const { isCollapsed, selectedCategoryId, setSelectedCategoryId, nestGroups } = useContext(SideNavigationContext)
    const [isFolded, setIsFolded] = useState(true)

    const isSelected = nestGroups || selectedCategoryId === id
    const _title = isCollapsed ? null : title

    return (
        <div className={`r-side-navigation-category ${isSelected ? 'r-state-selected' : ''}`}>
            <div
                className={'r-title'}
                onClick={() => {
                    const state = selectedCategoryId === id ? null : id
                    setSelectedCategoryId(state)
                }}
            >
                {title}
            </div>
            <div className={'r-category-items'}>{isSelected || nestGroups ? children : null}</div>
        </div>
    )
}

export default SideNavigationCategory
